/**
 * Hero sale countdown — updates chips with data-end ISO local datetime.
 */
(function () {
  function parseEnd(value) {
    if (!value) return NaN;
    // Prefer explicit local datetime without Z so merchant "store local" intent holds.
    var normalized = String(value).trim().replace(' ', 'T');
    var end = new Date(normalized).getTime();
    return end;
  }

  function formatRemaining(ms) {
    var days = Math.floor(ms / 864e5);
    var hours = Math.floor((ms % 864e5) / 36e5);
    var minutes = Math.floor((ms % 36e5) / 6e4);
    if (days > 0) return days + 'd ' + hours + 'h ' + minutes + 'm left';
    return hours + 'h ' + minutes + 'm left';
  }

  function initClock(el) {
    var end = parseEnd(el.getAttribute('data-end'));
    var endedLabel = el.getAttribute('data-ended-label') || 'Last chance';
    if (!end || isNaN(end)) return;

    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        el.textContent = endedLabel;
        return;
      }
      el.textContent = formatRemaining(diff);
    }

    tick();
    setInterval(tick, 30000);
  }

  document.querySelectorAll('.sale-clock[data-end]').forEach(initClock);
})();
